import {ReactElement, ReactNode} from "react";
import {useDropzone} from "react-dropzone";

export interface ImageDropzoneProps {
    onSetImage: (i: File) => void
    children: ReactNode
}

export function ImageDropzone(props: ImageDropzoneProps): ReactElement {
    const {getRootProps, getInputProps} = useDropzone({
        accept: ["image/jpeg", "image/png"],
        onDropAccepted: ([f]) => {
            props.onSetImage(f);
        }
    });

    return (
        <div className="w-full h-full" {...getRootProps()}>
            <input {...getInputProps()}/>
            {props.children}
        </div>
    );

}